import { render, staticRenderFns } from "./IncidentReportEmergencyBox.vue?vue&type=template&id=cb5cca26&"
import script from "./IncidentReportEmergencyBox.vue?vue&type=script&lang=js&"
export * from "./IncidentReportEmergencyBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports